import React, { useEffect, useMemo, useState } from 'react'
import { InputWithLabel } from '../../Components/Components';
import SiteTreeSelectAuto from '../Components/SiteTreeSelectAuto';
import { Button, DatePicker, Divider, Input, Select, Space, Table, Tag, message } from 'antd';
import SearchComponent from '../../Masters/GeneralComponents/SearchComponent';
import useFilterOptions from '../../Components/useFilterOptions';
import moment from 'moment';
import { capitalizeFirstLetter } from '../Components/Functions';
import axios from 'axios';
import FileSaver, { saveAs } from 'file-saver';
import SiteTreeMultiSelect from '../Components/SiteTreeMultiSelect';

export default function AsynchronousReports({ selectedOrg = {} }) {

    const [selected, setSelected] = useState({
        date: moment(),
        site_id: 0,
        sites: []
    });
    const filterableColumns = useMemo(() =>
        ['status'], []);

    const [visible, setVisible] = useState(false)
    const [reportType, setReportType] = useState([])
    const [reportName, setReportName] = useState(null)
    const [reportData, setReportData] = useState([])
    const [reportCode, setReportCode] = useState(null)
    const [asyReportId, setAsyReportId] = useState(null)
    const [data, setData] = useState({});
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [dateFilter, setDateFilter] = useState(false);
    const [singleSiteFilter, setSingleSiteFilter] = useState(false);
    const [multiSiteFilter, setMultiSiteFilter] = useState(false);
    const [masterState, setMasterState] = useState([]);
    const [filterOptions, setFilterOptions] = useFilterOptions(masterState, filterableColumns);

    const setSelectedKey = (key, value) => {
        setSelected(s => ({
            ...s,
            [key]: value,
        }));
    }


    const getData = async () => {
        await axios.get('/async_worker/get_report_codes')
            .then(res => {
                const data = res.data.data;
                setData(data);
                let reportMap = {};
                for (var report of data) {
                    reportMap[report.asy_report_id] = {
                        "value": report.report_code,
                        "label": report.report_code
                    }
                }
                setReportType(Object.values(reportMap))
            })
            .catch(err => {
                setData({});
                console.log(err);
                message.error('Error fetching data');
            })
    }

    async function getAllReportData() {
        setLoading(true);
        await axios.get('/async_worker/get_all_report_txn').then(res => {
            const data = res.data.data
            setReportData(data)
            setMasterState(data);
        }).catch(err => {
            setData({});
            setMasterState([]);
            console.log(err);
            message.error('Error  occuring to create report');
        })
        setLoading(false);
    }

    async function createReport() {

        const dataJSON = {
            report_name: reportName,
            report_code: reportCode,
            asy_report_id: asyReportId,
            filters: filters
        }

        await axios.post('/async_worker/create_report', { ...dataJSON }).then(res => {
            message.success("Report Created !!")
            showReport()
            getAllReportData()
        }).catch(err => {
            message.error('Error  occuring to create report');
        })
    }

    useEffect(() => {
        getData()
        getAllReportData()
    }, [])

    async function downloadFile(id) {

        try {
            const encodedId = encodeURIComponent(id);
            const url = `/async_worker/get_report_txn/${encodedId}`;
            const response = await axios.get(url, {
                responseType: 'blob',
            });

            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'file.txt';
            if (contentDisposition) {
                const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, '');
                }
            }
            saveAs(response.data, fileName);
        } catch (err) {
            console.log(err);
            message.error('Failed to download');
        }

    }

    function showReport() {
        setVisible(!visible)
        setDateFilter(false)
        setSingleSiteFilter(false)
        setMultiSiteFilter(false)
        setFilters({})
        setReportCode(null)
    }


    const searchReportCode = (reportCode) => {
        setDateFilter(false)
        setSingleSiteFilter(false)
        setMultiSiteFilter(false)
        const report = data.find((item) => item.report_code === reportCode);
        if (report) {
            const filterRequired = report.filter_required;
            const keys = Object.keys(filterRequired);
            setReportCode(reportCode)
            setAsyReportId(report.asy_report_id)
            const newObj = {};
            for (const key of keys) {
                newObj[key] = undefined;
            }
            setFilters(newObj)
            for (var key of keys) {
                if (key === "date") setDateFilter(true)
                else if (key === "site_id") setSingleSiteFilter(true)
                else if (key === "sites") setMultiSiteFilter(true)
            }
        }
    }

    const statusColorMap = { pending: "#cf1322", processing: "#faad14", completed: "#389e0d" }

    const columns = useMemo(() => [
        {
            title: 'Report ID',
            dataIndex: 'asy_txn_id',
            key: 'asy_txn_id',
        },
        {
            title: 'Report Name',
            dataIndex: 'report_name',
            key: 'report_name'
        },
        {
            title: 'Report Type',
            dataIndex: 'report_code',
            key: 'report_code'
        },
        {
            title: 'Created Date',
            dataIndex: 'created_time',
            key: 'created_time',
            render: (text, record) =>  moment(text).format('Do MMM YYYY, HH:mm A'),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filters: filterOptions.status,
            render: (text, record) => (
                <Tag
                    color={statusColorMap[text] || "#000000"}
                    key={record.status}
                    style={{ fontWeight: '700' }}
                >
                    {text?.toUpperCase()}
                </Tag>
            ),
            onFilter: (value, record) => record.status == value,
            filterSearch: true,
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'action',
            render: (text, record) => (<Button disabled={record.status === "completed" ? false : true} onClick={() => downloadFile(record.asy_txn_id)} danger>Download</Button>)
        }
    ].filter((column) => !column.hidden)
    )

    return (
        <div className='my-form-outer'>
            <div className='my-form-header'>
                <span className='my-form-title'>Asynchronous reports</span>
                <div>
                    <SearchComponent
                        masterState={masterState}
                        state={reportData}
                        setState={setReportData}
                        searchOptions={[
                            { keyName: 'asy_txn_id', label: 'Report ID' },
                            { keyName: 'report_name', label: 'Report Name' },
                            { keyName: 'report_code', label: 'Report Type' },
                            { keyName: 'status', label: 'Status' },
                        ]}
                        isLabelInline={false}
                    />
                </div>
            </div>
            <div style={{ display: 'flex', alignSelf: 'center' }}>
                {!visible && <Button type={visible ? "danger" : 'primary'} onClick={() => showReport()}>New Report</Button>}
                {
                    visible && <div>
                        <div style={{ display: 'flex' }}>
                            <Select
                                onSelect={(value) => searchReportCode(value)}
                                style={{ width: '150px' }}
                                defaultValue={"Select Report Type"}
                                options={reportType}
                            />

                        </div>
                    </div>
                }
                {visible && <Button style={{ marginLeft: '20px' }} type="danger" onClick={() => showReport()}>Cancel</Button>}
            </div>

            {visible && <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
                <Space>
                    {
                        (singleSiteFilter || dateFilter) &&
                        <InputWithLabel label="Report Name" reqMark>
                            <Input placeholder='Report Name' onChange={(e) => setReportName(e.target.value)} />
                        </InputWithLabel>
                    }
                    {
                        singleSiteFilter &&
                        <Space>
                            <SiteTreeSelectAuto
                                selectedOrg={selectedOrg}
                                value={selected.site_id}
                                onChange={(value) => { setFilters({ ...filters, site_id: value }) }}
                                setValue={(value) => { setSelectedKey('site_id', value) }}
                            />
                        </Space>
                    }
                    {
                        multiSiteFilter &&
                        <Space>
                            <SiteTreeMultiSelect
                                selectedOrg={selectedOrg}
                                value={selected.sites}
                                setValue={(value) => {
                                    setSelectedKey('sites', value)
                                    setFilters({ ...filters, sites: value })
                                }}
                            />
                        </Space>
                    }
                    {
                        dateFilter &&
                        <Space>
                            <InputWithLabel label={'Date'} reqMark>
                                <DatePicker
                                    className="my-form-input"
                                    format={"YYYY-MM-DD"}
                                    // value={selected.date}
                                    // onChange={(value) => { setSelectedKey('date', value) }}
                                    onChange={(value) => { setFilters({ ...filters, date: value.format("YYYY-MM-DD") }) }}
                                    allowClear={false}
                                    disabledDate={(current) => { return current && current > moment().endOf('day'); }}
                                />
                            </InputWithLabel>
                        </Space>

                    }
                    <InputWithLabel label={' '}>
                        {reportCode && <Button onClick={() => createReport()} type='primary'>Submit</Button>}
                    </InputWithLabel>

                </Space>
            </div>}
            <Divider />
            <Table
                columns={columns}
                dataSource={reportData}
                loading={loading}
                pagination={{
                    position: ['bottomRight'],
                    showSizeChanger: true,
                    defaultPageSize: 15,
                }}
                size='small'
            />
        </div>
    )
}
